<button
  data-test="oUCxwCKJ"
  (mousedown)="handleButtonClick()"
  class="button button_sm button_white"
  type="button"
>
  <span data-test="LfZPlJjc" class="button__icon button__icon_left">
    <i data-test="V2qERNiG" class="material-icons">add</i>
  </span>
  <span data-test="ciMvyZU5">Add {{ itemName }}</span>
</button>
<div
  data-test="3JeH5Pct"
  class="dropdown mw-100 pt-0"
  [class.active]="active"
  [class.show]="active"
  #scrollElem
>
  <div data-test="al1uY7FY" class="dropdown__wrap">
    <input
      data-test="QFnAomi1"
      #input
      [readonly]="!filter"
      [attr.placeholder]="placeholder"
      (input)="onFilter(input.value)"
      (keydown)="changeChosenByKeyboard($event)"
      (keyup.enter)="addNew(input.value); input.value = ''"
      (focus)="resetFilter()"
      class="dropdown__input input input_xs"
      placeholder="{{ placeholder }}"
      type="text"
    />
    <ul
      data-test="jqGaaBaQ"
      class="dropdown__menu"
      data-simplebar="init"
      #listElem
      style="max-height: 150px"
    >
      <div
        data-test="r4higsKK"
        class="simplebar-track vertical"
        style="visibility: visible"
      >
        <div
          data-test="IzgTADYp"
          class="simplebar-scrollbar"
          style="visibility: visible; top: 37px; height: 119px"
        ></div>
      </div>
      <div
        data-test="KoH_CUIH"
        class="simplebar-track horizontal"
        style="visibility: hidden"
      >
        <div data-test="BmxoCpg6" class="simplebar-scrollbar"></div>
      </div>
      <div
        data-test="F1ih9638"
        class="simplebar-scroll-content"
        style="padding-right: 20px; margin-bottom: -20px"
      >
        <div data-test="F5Bp1lrO" class="simplebar-content" style="padding-bottom: 20px">
          <li
            data-test="2sIL4gal"
            (mousedown)="addNew(input.value); input.value = ''"
            class="dropdown__menu-item"
            *ngIf="canAddNew()"
          >
            <a data-test="PzbyzQ20" class="dropdown__menu-link">
              <i data-test="svTLNvQO" class="icon material-icons md-16">add</i>
              <span data-test="3apv_6fD">
                Add new {{ itemName | lowercase }}
                <strong data-test="-xNDD7xD">{{ input.value }}</strong>
              </span>
            </a>
          </li>
          <li
            data-test="6yV-7fhk"
            class="dropdown__menu-item"
            *ngFor="let option of options"
            [class.active]="isChosenByKeyboard(option)"
            [class.checked]="isChosen(option)"
          >
            <span
              data-test="kNirEx_c"
              class="dropdown__menu-link"
              (mousedown)="selectValue(option)"
            >
              {{ labelKey ? option[labelKey] : option }}
            </span>
          </li>
        </div>
      </div>
    </ul>
  </div>
</div>
